import HeightFillingImage from 'components/Common/HeightFillingImage'
import VideoLightbox from 'components/Luxkit/Carousel/VideoLightbox'
import SolidPlayIcon from 'components/Luxkit/Icons/solid/SolidPlayIcon'
import LightBoxContext from 'components/Luxkit/Modal/LightBoxContext'
import { mediaQueryDown } from 'components/utils/breakpoint'
import PaletteProvider from 'contexts/PaletteProvider'
import { rem } from 'polished'
import React, { ForwardedRef, useContext } from 'react'
import styled from 'styled-components'

const PlayButton = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transition: transform 0.2s;
  transform: translateY(-50%) translateX(-50%) scale(1);
  border-radius: ${props => props.theme.borderRadius.round};
  background-color: ${props => props.theme.palette.neutral.eight};
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${rem(48)};
  width: ${rem(48)};

  ${mediaQueryDown.mobile} {
    height: ${rem(36)};
    width: ${rem(36)};
  }
`

const StyledPlayIcon = styled(SolidPlayIcon)`
  height: ${rem(24)};
  width: ${rem(24)};

  ${mediaQueryDown.mobile} {
    height: ${rem(20)};
    width: ${rem(20)};
  }
`

const VimeoWrapper = styled.div`
  width: 100%;
  position: relative;
  background-color: ${props => props.theme.palette.neutral.one};

  > * {
    pointer-events: none;
  }

  &:focus, &:hover {
    > ${PlayButton} {
      transform: translateY(-50%) translateX(-50%) scale(1.2);
    }
  }
`

export function BeInspiredBannerVideo({ videoRef }: { videoRef: ForwardedRef<HTMLImageElement> | null }) {
  const showLightbox = useContext(LightBoxContext)

  return (
    <PaletteProvider type="default">
      <VimeoWrapper onClick={() => showLightbox(<VideoLightbox videoId="849995242" playOnMount />)}>
        <HeightFillingImage
          ref={videoRef}
          fit="center"
          id="zi3gzbknyqn3fv4sh9ah"
          alt="Be Inspired video"
          mobileAspectRatio="16:9"
        />
        <PlayButton>
          <StyledPlayIcon />
        </PlayButton>
      </VimeoWrapper>
    </PaletteProvider>
  )
}
